<script lang="ts">
  import type { User, RawUser } from "$types";
  export let user: User | RawUser;
  let last_initial = user.last_name?.charAt(0) ?? "";

  $: if (
    Array.isArray(user.profile) &&
    user.profile.length &&
    user.profile[0].display_name
  ) {
    user.profile = user.profile[0];
  }
</script>

{#if user.profile?.display_name}
  {user.profile.display_name}
{:else}
  {user.first_name} {last_initial}
{/if}
